// import axios from "../utils/axios";

// export const getAdminInvoicesApi =
//   () => {
//     return axios.get(
//       "/api/admin/invoices",
//       {
//         withCredentials: true,
//       }
//     );
//   };

import axios from "../utils/axios";

export const getAdminInvoicesApi = (params = {}) => {
  return axios.get("/api/admin/invoices", {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      status: params.status || undefined,
      restaurantId: params.restaurantId || undefined,
      startDate: params.startDate || undefined,
      endDate: params.endDate || undefined,
      search: params.search || undefined,
    },
    withCredentials: true,
  });
};